import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CategoryCharacteristicSettingsResponse as SchemaCategoryCharacteristicSettingsResponse } from '../schemas/CategoryCharacteristicSettingsResponse';
import { type ChangedCategoryCharacteristicSettingsInBulk as SchemaChangedCategoryCharacteristicSettingsInBulk } from '../schemas/ChangedCategoryCharacteristicSettingsInBulk';
import { type UpdateCategoryCharacteristicSettingsInBulkRequest as SchemaUpdateCategoryCharacteristicSettingsInBulkRequest } from '../schemas/UpdateCategoryCharacteristicSettingsInBulkRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Categories
 */
export const UpdateCategoryCharacteristicSettingsInBulkContentType = 'application/json' as const;
export type UpdateCategoryCharacteristicSettingsInBulkRequest =
    | SchemaChangedCategoryCharacteristicSettingsInBulk
    | SchemaUpdateCategoryCharacteristicSettingsInBulkRequest;
export type UpdateCategoryCharacteristicSettingsInBulkResponses = LinkCommonErrorResponses & {
    /**
     * @description Successfully updated all settings
     */
    '200': {
        'application/json': SchemaCategoryCharacteristicSettingsResponse[];
    };
};
export type UpdateCategoryCharacteristicSettingsInBulkResponseSuccess =
    UpdateCategoryCharacteristicSettingsInBulkResponses['200']['application/json'];
export type UpdateCategoryCharacteristicSettingsInBulkSearchParams = undefined;
export type UpdateCategoryCharacteristicSettingsInBulkPathParameters = {
    category_id: string;
};
export const UpdateCategoryCharacteristicSettingsInBulkUrl =
    '/categories/{category_id}/characteristics/settings' as const;
export const UpdateCategoryCharacteristicSettingsInBulkMethod = 'PUT' as const;
export const getUpdateCategoryCharacteristicSettingsInBulkUrl = (
    params: UpdateCategoryCharacteristicSettingsInBulkPathParameters
) =>
    UpdateCategoryCharacteristicSettingsInBulkUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof UpdateCategoryCharacteristicSettingsInBulkPathParameters) => String(params[param])
    );
